export default {
  name: "NavbarSection",

  data() {
    return ({
      navItems: [
        {
          label: "Core Solutions",
          href: "#",
          active: true,
          icon: `
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
              <rect x="4" y="4" width="6" height="6" rx="1.4"></rect>
              <rect x="14" y="4" width="6" height="6" rx="1.4"></rect>
              <rect x="4" y="14" width="6" height="6" rx="1.4"></rect>
              <rect x="14" y="14" width="6" height="6" rx="1.4"></rect>
            </svg>
          `,
        },
        {
          label: "Contact",
          href: "#",
          active: false,
          icon: `
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
              <path d="M7.5 5.5h9a2 2 0 0 1 2 2v9"></path>
              <path d="M18.5 13.5c0 3.1-3.5 5.8-5.7 7.1a1.6 1.6 0 0 1-1.6 0c-2.2-1.3-5.7-4-5.7-7.1a4.5 4.5 0 0 1 8-2.8 4.5 4.5 0 0 1 8 2.8Z"></path>
            </svg>
          `,
        },
        {
          label: "Privacy",
          href: "#",
          active: false,
          icon: `
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
              <path d="M12 3l7 4v5c0 5-3.4 8.4-7 9-3.6-.6-7-4-7-9V7l7-4Z"></path>
              <path d="M9.5 12.5 11 14l3.5-4"></path>
            </svg>
          `,
        },
      ],
    });
  },
};
